// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD8juvRT6u260BuKj6kuVaAHhHYeoc8wv8",
  authDomain: "unfold-news.firebaseapp.com",
  projectId: "unfold-news",
  storageBucket: "unfold-news.appspot.com",
  messagingSenderId: "480020665125",
  appId: "1:480020665125:web:99c9c7b8bfaf906be080cc"
};

// Initialize Firebase
initializeApp(firebaseConfig);
